<template>
  <div class="alignText">
    <v-btn class="my-5" @click="redirectZohoForm" color="primary">{{ $t('publicPlayer.participate') }}</v-btn>
    <p class="subText">{{ $t('publicPlayer.info') }}</p>
  </div>
</template>

<script>
export default {
  name: 'Webinaire',

  props: ['reference'],

  methods: {
    redirectZohoForm() {
      const url =
        'https://forms.zohopublic.com/stampyt/form/InscriptionfonctionnalitvidobyStampyt/formperma/i0LhDXVpsBj3gP-eoa4HQug6Yz3Mm12OikK3f6Wf-IE'

      const win = window.open(url, '_blank')
      win.focus()

      this.$mam.shootingsWebinaireRedirect()
    }
  }
}
</script>

<style lang="sass" scoped>
.alignText
  text-align: center
.subText
  font-size: '11px'
  opacity: .67
</style>
